import { useEffect, useRef, useState } from 'react';
import { useMotionValue, animate, Easing } from 'motion/react';

type AnimationOptions = {
    duration?: number;
    ease?: Easing;
  };

export function useAnimatedNumber(
    value: number | null,
    { duration = 0.9, ease = 'easeInOut' }: AnimationOptions = {},
) {
    const mv = useMotionValue<number>(0);
    const [display, setDisplay] = useState<number | null>(value);
    const latest = useRef<number | null>(value);

    useEffect(() => {
        if (value == null) {
            latest.current = null;
            setDisplay(null);
            return undefined;
        }

        if (latest.current == null && value === 0) {
            setDisplay(0);
        }

        const from = latest.current ?? 0;
        latest.current = value;

        const controls = animate(mv, value, {
            from,
            duration,
            ease,
        });

        const unsub = mv.on('change', v => setDisplay(v));

        return () => {
            controls.cancel();
            unsub();
        };
    }, [value]);

    return display;
}
